var _line, _line2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 17,
    viewBox: "0 0 320 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 8.75,
    x2: 135.5,
    y2: 8.75,
    stroke: "url(#paint0_linear_15_6687)",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 184.5,
    y1: 8.75,
    x2: 319.5,
    y2: 8.74999,
    stroke: "url(#paint1_linear_15_6687)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.88 14.084C156.143 14.084 155.457 13.9627 154.822 13.72C154.197 13.468 153.651 13.118 153.184 12.67C152.727 12.2127 152.367 11.6853 152.106 11.088C151.854 10.4813 151.728 9.81867 151.728 9.1C151.728 8.38133 151.854 7.72333 152.106 7.126C152.367 6.51933 152.727 5.992 153.184 5.544C153.651 5.08667 154.197 4.73667 154.822 4.494C155.447 4.242 156.133 4.116 156.88 4.116C157.617 4.116 158.299 4.242 158.924 4.494C159.549 4.73667 160.091 5.082 160.548 5.53C161.015 5.978 161.374 6.50533 161.626 7.112C161.887 7.71867 162.018 8.38133 162.018 9.1C162.018 9.81867 161.887 10.4813 161.626 11.088C161.374 11.6947 161.015 12.222 160.548 12.67C160.091 13.118 159.549 13.468 158.924 13.72C158.299 13.9627 157.617 14.084 156.88 14.084ZM156.88 13.16C157.468 13.16 158.009 13.062 158.504 12.866C159.008 12.6607 159.442 12.376 159.806 12.012C160.179 11.6387 160.469 11.2093 160.674 10.724C160.879 10.2293 160.982 9.688 160.982 9.1C160.982 8.512 160.879 7.97533 160.674 7.49C160.469 6.99533 160.179 6.566 159.806 6.202C159.442 5.82867 159.008 5.544 158.504 5.348C158.009 5.14267 157.468 5.04 156.88 5.04C156.292 5.04 155.746 5.14267 155.242 5.348C154.738 5.544 154.299 5.82867 153.926 6.202C153.562 6.566 153.273 6.99533 153.058 7.49C152.853 7.97533 152.75 8.512 152.75 9.1C152.75 9.67867 152.853 10.2153 153.058 10.71C153.273 11.2047 153.562 11.6387 153.926 12.012C154.299 12.376 154.738 12.6607 155.242 12.866C155.746 13.062 156.292 13.16 156.88 13.16ZM164.13 14V6.65H165.082V8.652L164.984 8.302C165.189 7.742 165.535 7.31733 166.02 7.028C166.505 6.72933 167.107 6.58 167.826 6.58V7.546C167.789 7.546 167.751 7.546 167.714 7.546C167.677 7.53667 167.639 7.532 167.602 7.532C166.827 7.532 166.221 7.77 165.782 8.246C165.343 8.71267 165.124 9.38 165.124 10.248V14H164.13Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_6687",
    x1: 0.5,
    y1: 9.5,
    x2: 135.5,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_6687",
    x1: 184.5,
    y1: 9.5,
    x2: 319.5,
    y2: 9.49999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/or.268837b4fcd06bebf80308ca532708f6.svg";
export { ForwardRef as ReactComponent };